import { Outlet, Link } from "react-router-dom";
import TWNavbar from "./tw-nav-bar";
import Footer from './footer-panel';
import './../css/mk-brand.css';

const Layout = () => {
    return (
        <div className="bg-black h-screen w-full">
            <TWNavbar className="nav" />
            <Outlet />
            <Footer />
        </div>
    )
};

export default Layout;
